import {
  $tagsTableSearchInputValue,
  TagsTable,
  TagsTableGate,
  tagsTableQuery,
  tagsTableSearchChanged,
} from '@/entities/tags'
import { STRINGS } from '@/shared/config'
import { isValidTab } from '@/shared/lib/tabs'
import {
  BorderlessTabs,
  ContentWrapper,
  EmptyContent,
  HeaderContent,
  HidingSpin,
} from '@/shared/ui'
import { PrimaryButton } from '@/shared/ui'
import { TagForm, tagFormModalOpened } from '@/widgets/TagForm'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Input } from 'antd'
import { useUnit } from 'effector-react'

import {
  type TagsListPageTabsKeys,
  TagsListPageTabsKeysArray,
  TagsListPageTabsKeysEnum,
  TagsListPageTabsKeysTypesEnum,
} from './lib/tabs'
import {
  $tagsListPageLatestFilters,
  $tagsListPageLatestPage,
  $tagsListPageLatestPageSize,
  $tagsListPageLatestSearch,
  $tagsListPageTab,
  TagsListPageGate,
  tagsListPageTabChanged,
} from './model/tags-list.model'

export function TagsListPage() {
  const { data, pending, error } = useUnit(tagsTableQuery)

  const search = useUnit($tagsTableSearchInputValue)
  const changeSearch = useUnit(tagsTableSearchChanged)

  const latestSearch = useUnit($tagsListPageLatestSearch)
  const latestFilters = useUnit($tagsListPageLatestFilters)
  const latestPage = useUnit($tagsListPageLatestPage)
  const latestPageSize = useUnit($tagsListPageLatestPageSize)

  const openTagFormModal = useUnit(tagFormModalOpened)

  const tab = useUnit($tagsListPageTab)
  const changeTab = useUnit(tagsListPageTabChanged)

  const handleTabChange = (newTab: string) => {
    if (!isValidTab<TagsListPageTabsKeys>(newTab, TagsListPageTabsKeysArray))
      return
    changeTab(newTab)
  }

  return (
    <>
      <TagsListPageGate />
      <TagForm
        isModal
        defaultContentType={TagsListPageTabsKeysTypesEnum[tab]}
      />
      <HeaderContent
        title="Жанры"
        description="Здесь можно создавать, редактировать и удалять жанры для музыки, подкастов и альбомов"
        buttonSlot={
          <PrimaryButton
            onClick={() => openTagFormModal()}
            icon={<PlusOutlined />}
          >
            Создать
          </PrimaryButton>
        }
      />

      <ContentWrapper>
        <BorderlessTabs
          activeKey={tab}
          tabBarExtraContent={
            <Input
              placeholder={STRINGS.placeholder_search_by_name_input}
              allowClear
              addonAfter={<SearchOutlined />}
              value={search || ''}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const searchQueryString = event.target.value
                changeSearch(searchQueryString)
              }}
              style={{
                minWidth: 300,
              }}
            />
          }
          onChange={handleTabChange}
          items={[
            {
              label: 'Музыка',
              key: TagsListPageTabsKeysEnum.music,
            },
            {
              label: 'Подкасты',
              key: TagsListPageTabsKeysEnum.podcast,
            },
            {
              label: 'Аудиокниги',
              key: TagsListPageTabsKeysEnum.audiobook,
            },
            {
              label: 'Настроение',
              key: TagsListPageTabsKeysEnum.mood,
            },
          ]}
        />
        <TagsTableGate
          initialFilters={latestFilters}
          initialPage={latestPage}
          initialPageSize={latestPageSize}
          initialSearch={latestSearch}
        />
        <HidingSpin spinning={pending || (!data?.items && !error)}>
          {data?.items && data.items.length > 0 ? (
            <>
              <TagsTable
                onEdit={(tagId: number) => {
                  openTagFormModal({ id: tagId })
                }}
              />
            </>
          ) : search?.length && search?.length > 0 ? (
            <EmptyContent description={STRINGS.nothing_was_found} />
          ) : (
            <EmptyContent />
          )}
        </HidingSpin>
      </ContentWrapper>
    </>
  )
}
